
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaitaxiservice() {



const cardData = {
  keyword: 'Navi Mumbai Taxi Service',
  heading: 'Skyline Cabs: Navi Mumbai Taxi Service',
  headingDescription: 'Skyline Cabs offers reliable and affordable Navi Mumbai Taxi Service for local city travel, airport transfers, corporate rides, and outstation trips. Whether you need taxi in Kharghar, taxi service in Vashi Navi Mumbai, or cab service in Navi Mumbai for daily commuting, we provide professional drivers and well-maintained AC vehicles. Our services cover all major areas including Kharghar, Vashi, Nerul, Belapur, and Panvel with transparent pricing and easy online taxi booking Navi Mumbai system. From Navi Mumbai airport taxi service to taxi from Navi Mumbai to airport, Skyline Cabs ensures punctual pickup and comfortable travel experience across the city.',

  top: 'Top Places to Visit in Navi Mumbai with Skyline Cabs',

  topPlaces: [
    {
      title: "Central Park, Kharghar",
      description: "Central Park is one of the largest urban parks in Navi Mumbai offering scenic walking tracks, gardens, and open-air event spaces. It is ideal for families, joggers, and nature lovers. Located in Kharghar, it is easily accessible via taxi in Kharghar and cab service in Navi Mumbai. The park provides peaceful surroundings and beautiful hill views."
    },
    {
      title: "Palm Beach Road",
      description: "Palm Beach Road connects Vashi to Belapur and is known for smooth infrastructure and sea-facing views. It is perfect for scenic drives and photography. Visitors often travel through taxi service in Vashi Navi Mumbai for easy access."
    },
    {
      title: "Belapur Fort",
      description: "Belapur Fort is a historic site offering panoramic city views and green surroundings. It is a popular tourist attraction in Navi Mumbai."
    },
    {
      title: "Pandavkada Waterfalls",
      description: "Pandavkada Waterfalls is a famous monsoon destination in Kharghar attracting nature enthusiasts and trekkers."
    },
    {
      title: "DY Patil Stadium",
      description: "DY Patil Stadium hosts major sports and entertainment events and is a key landmark in Navi Mumbai."
    },
    {
      title: "Nerul Balaji Temple",
      description: "Nerul Balaji Temple is a peaceful spiritual destination offering calm surroundings and architectural beauty."
    },
    {
      title: "Seawoods Grand Central Mall",
      description: "Seawoods Grand Central Mall offers premium shopping, dining, and entertainment experiences."
    },
    {
      title: "Karnala Bird Sanctuary",
      description: "Karnala Bird Sanctuary is a natural getaway known for bird watching and trekking trails."
    },
    {
      title: "Rock Garden, Nerul",
      description: "Rock Garden provides sea-facing views and walking paths ideal for families and couples."
    },
    {
      title: "Utsav Chowk",
      description: "Utsav Chowk is known for its vibrant architecture and lively atmosphere surrounded by restaurants and cafes."
    }
  ],

  services: [
    {
      name: "Local Navi Mumbai Taxi Service",
      description: "Skyline Cabs provides professional Navi Mumbai taxi service covering taxi in Navi Mumbai, Navi Mumbai taxi, and Navi Mumbai cab service for daily commuting and city travel. Whether you need taxi in Kharghar, Kharghar taxi service, taxi stand in Kharghar pickup, or taxi service in Vashi Navi Mumbai, we ensure punctual arrival and transparent pricing. Customers looking for cab service in Navi Mumbai, cabs Navi Mumbai, or cabs in Navi Mumbai can easily book taxi service in Navi Mumbai through our secure online taxi booking Navi Mumbai platform. Our best taxi service in Navi Mumbai offers comfortable sedan, SUV, and AC vehicles with experienced drivers."
    },
    {
      name: "Airport Taxi Service Navi Mumbai",
      description: "Our Navi Mumbai airport taxi service includes Airport taxi Navi Mumbai for smooth transfers to domestic and international terminals. Whether you require Mumbai airport taxi service Navi Mumbai or taxi from Navi Mumbai to airport, Skyline Cabs guarantees punctual pickup, professional chauffeurs, and fixed fare structure. Travelers searching for reliable taxi service Navi Mumbai for airport transfers or cheapest taxi service in Navi Mumbai benefit from transparent pricing and sanitized vehicles. Our online taxi booking Navi Mumbai platform ensures quick confirmation and stress-free airport travel."
    },
    {
      name: "Online & Advance Taxi Booking Navi Mumbai",
      description: "Skyline Cabs simplifies online taxi booking Navi Mumbai for instant and advance reservations. Customers can book taxi service in Navi Mumbai within minutes using our secure digital platform. Whether searching for best taxi service in Navi Mumbai, cheapest taxi service in Navi Mumbai, or reliable taxi service Navi Mumbai, we provide confirmed rides with professional drivers. Our Navi Mumbai taxi service supports city travel, airport transfers, and outstation trips with complete transparency."
    },
    {
      name: "Area-Based Taxi Service Coverage",
      description: "We provide taxi in Kharghar, taxi stand in Kharghar pickups, Kharghar taxi service, taxi service in Vashi Navi Mumbai, Nerul rides, Belapur transfers, and full Navi Mumbai taxi coverage. Customers searching for cabs Navi Mumbai or cab service in Navi Mumbai receive quick response and safe travel. Our Navi Mumbai taxi ensures smooth connectivity across residential and commercial hubs."
    }
  ],

  tableData: [
    ["Taxi in Kharghar", "Kharghar Taxi Service"],
    ["Taxi Stand in Kharghar", "Taxi Service in Vashi Navi Mumbai"],
    ["Navi Mumbai Taxi Service", "Taxi Service in Navi Mumbai"],
    ["Navi Mumbai Taxi", "Taxi in Navi Mumbai"],
    ["Navi Mumbai Cab Service", "Cab Service in Navi Mumbai"],
    ["Cabs Navi Mumbai", "Cabs in Navi Mumbai"],
    ["Book Taxi Service in Navi Mumbai", "Online Taxi Booking Navi Mumbai"],
    ["Best Taxi Service in Navi Mumbai", "Cheapest Taxi Service in Navi Mumbai"],
    ["Reliable Taxi Service Navi Mumbai", "Navi Mumbai Airport Taxi Service"],
    ["Airport Taxi Navi Mumbai", "Taxi from Navi Mumbai to Airport"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Complete Citywide Coverage Across Navi Mumbai",
      WhyChoosedescription: "Skyline Cabs provides Navi Mumbai taxi service across Kharghar, Vashi, Nerul, Belapur, Panvel, and surrounding areas. Whether you need taxi in Navi Mumbai for office travel, shopping trips, or airport transfers, our fleet is available throughout the city. We ensure quick response time and efficient route management. Our coverage includes taxi stand in Kharghar pickups and taxi service in Vashi Navi Mumbai. This wide network ensures passengers never face delays."
    },
    {
      WhyChooseheading: "Transparent & Affordable Navi Mumbai Taxi Fare",
      WhyChoosedescription: "Our Navi Mumbai taxi fare structure is clear and upfront with no hidden charges. Whether booking cheapest taxi service in Navi Mumbai or premium ride options, customers receive accurate fare estimation before confirmation. We maintain competitive pricing without compromising service quality."
    },
    {
      WhyChooseheading: "24x7 Availability Including Airport Transfers",
      WhyChoosedescription: "Skyline Cabs operates round-the-clock Navi Mumbai taxi service including early morning and late-night airport taxi Navi Mumbai bookings. Whether you require taxi from Navi Mumbai to airport or Mumbai airport taxi service Navi Mumbai, we ensure punctual pickup."
    },
    {
      WhyChooseheading: "Professional & Verified Drivers",
      WhyChoosedescription: "Our drivers are background-verified, trained, and experienced in city routes ensuring safe and comfortable travel experience."
    },
    {
      WhyChooseheading: "Clean & Well-Maintained AC Vehicles",
      WhyChoosedescription: "All vehicles under Navi Mumbai cab service are sanitized and regularly maintained for hygienic and comfortable rides."
    },
    {
      WhyChooseheading: "Easy Online Taxi Booking Navi Mumbai",
      WhyChoosedescription: "Book taxi service in Navi Mumbai easily through our secure online taxi booking Navi Mumbai system with instant confirmation."
    },
    {
      WhyChooseheading: "Reliable & On-Time Service Guarantee",
      WhyChoosedescription: "Our reliable taxi service Navi Mumbai ensures punctual arrival and smooth ride experience every time."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options for Every Need",
      WhyChoosedescription: "Choose from sedan, SUV, Ertiga, or Innova based on your comfort and travel requirement."
    }
  ]
}



const faqData = [
    {
        id: 1,
        question: 'How can I book Navi Mumbai Taxi Service with Skyline Cabs?',
        answer:
            'You can easily book Navi Mumbai Taxi Service through our website or mobile app. Enter your pickup and drop location, choose your preferred vehicle, and confirm your ride instantly.',
    },
    {
        id: 2,
        question: 'Is Navi Mumbai Taxi Service available 24/7?',
        answer:
            'Yes, Skyline Cabs offers 24/7 Navi Mumbai Taxi Service for local travel, airport transfers, and outstation trips, including late-night and early-morning rides.',
    },
    {
        id: 3,
        question: 'What vehicles are available under Navi Mumbai Taxi Service?',
        answer:
            'We provide Sedans, SUVs, Ertiga, Innova Crysta, and premium cars for Navi Mumbai Taxi Service — suitable for individuals, families, and corporate travel.',
    },
    {
        id: 4,
        question: 'Are the fares for Navi Mumbai Taxi Service transparent?',
        answer:
            'Yes, Skyline Cabs follows a transparent pricing policy. The fare displayed during booking includes driver charges and applicable taxes with no hidden fees.',
    },
    {
        id: 5,
        question: 'Do you provide airport taxi service in Navi Mumbai?',
        answer:
            'Absolutely. Our Navi Mumbai Taxi Service includes reliable airport pickup and drop with real-time tracking and punctual service.',
    },
    {
        id: 6,
        question: 'Can I book Navi Mumbai Taxi Service for outstation trips?',
        answer:
            'Yes, we provide outstation taxi services from Navi Mumbai to destinations like Pune, Nashik, Lonavala, Mahabaleshwar, and more at competitive rates.',
    },
    {
        id: 7,
        question: 'Are online payment options available?',
        answer:
            'Yes, we support secure online payments via UPI, credit/debit cards, and net banking. Instant confirmation is sent after successful payment.',
    },
    {
        id: 8,
        question: 'Can I pre-book my taxi in Navi Mumbai?',
        answer:
            'Yes, you can schedule your Navi Mumbai Taxi Service in advance for any date and time to ensure guaranteed availability and timely pickup.',
    },
    {
        id: 9,
        question: 'Is Navi Mumbai Taxi Service suitable for corporate clients?',
        answer:
            'Definitely. Skyline Cabs provides professional drivers, clean vehicles, punctual service, and billing support for corporate and business travel.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Navi Mumbai Taxi Service?',
        answer:
            'Skyline Cabs offers reliable taxi service, experienced chauffeurs, well-maintained vehicles, affordable pricing, and 24x7 customer support — making us a trusted Navi Mumbai Taxi Service provider.',
    },
];

const someReviews = [
    {
        name: "Mr. Nikhil Jadhav",
        rating: 5,
        review: "Booked Navi Mumbai Taxi Service with Skyline Cabs for a local trip. The car was clean, driver was courteous, and the ride was very smooth. Excellent experience!"
    },
    {
        name: "Ms. Aarti Kulkarni",
        rating: 4,
        review: "Very reliable Navi Mumbai Taxi Service. Easy booking process, transparent pricing, and on-time pickup. Highly recommend Skyline Cabs."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Taxi Service",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-taxi-service.jpg",
  "description": "Book Navi Mumbai Taxi Service with Skyline Cabs for local, airport and outstation travel. Reliable and affordable taxi service available in Kharghar, Vashi, Nerul, Belapur and Panvel with sedan, SUV and Innova Crysta.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "599",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-taxi-service"
  }
};



    return (
        <div>

<Helmet>
  <title>Navi Mumbai Taxi Service | Local & Airport Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai Taxi Service with Skyline Cabs for reliable local and airport taxi. Available in Kharghar, Vashi and across Navi Mumbai at affordable fares with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="taxi in kharghar, navi mumbai taxi service, cabs navi mumbai, cabs in navi mumbai, cab service in navi mumbai, kharghar taxi service, navi mumbai taxi, taxi in navi mumbai, taxi stand in kharghar, taxi service in vashi navi mumbai, taxi service in navi mumbai, navi mumbai cab service, book taxi service in navi mumbai, online taxi booking navi mumbai, best taxi service in navi mumbai, cheapest taxi service in navi mumbai, reliable taxi service navi mumbai, navi mumbai airport taxi service, airport taxi navi mumbai, mumbai airport taxi service navi mumbai, taxi from navi mumbai to airport, innova crysta navi mumbai taxi service, innova cab navi mumbai taxi service, Skyline Cabs Navi Mumbai Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/121.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaitaxiservice;